module.exports = __webpack_public_path__ + "img/flash.eb845aa6.jpg";